/**
 * Encodes a Uint8Array to a base64 string. Another method using array iteration.
 * More memory-efficient and stack-safe than `uint8ArrayToBase64` for larger arrays.
 * @param {Uint8Array} buffer The Uint8Array to encode.
 * @returns {string} The base64 encoded string.
 */
export const arrayBufferToBase64 = (buffer: Uint8Array): string => {
	let binary = "";
	const bytes = new Uint8Array(buffer); // or use buffer directly if already Uint8Array

	const len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i] as number);
	}
	return btoa(binary);
};

/**
 * Decodes a base64 string to a Uint8Array.
 * @param {string} base64 The base64 encoded string to decode.
 * @returns {Uint8Array} The decoded Uint8Array.
 */
export const base64ToArrayBuffer = (base64: string): Uint8Array => {
	let binary_string: string;

	if (typeof window !== "undefined" && typeof window.atob === "function") {
		// Browser environment
		binary_string = window.atob(base64);
	} else {
		// Node.js or other environment
		binary_string = Buffer.from(base64, "base64").toString("binary");
	}

	const len = binary_string.length;
	const bytes = new Uint8Array(len);

	for (let i = 0; i < len; i++) {
		bytes[i] = binary_string.charCodeAt(i);
	}

	return bytes;
};
